import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Papa from 'papaparse';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
export const CSV_FORMATS = [{
  name: 'initial',
  columns: [{
    name: 'UnitName',
    reference: 'unitName',
    isRequired: 1,
    dataType: 'String'
  }, {
    name: 'ResidentName',
    reference: 'residentName',
    isRequired: 0,
    dataType: 'String'
  }, {
    name: 'ResidencyStatus',
    reference: 'residencyName',
    isRequired: 1,
    dataType: 'String'
  }, {
    name: 'SerialNumber',
    reference: 'serialNumber',
    isRequired: 0,
    dataType: 'String'
  }, {
    name: 'StartMeterDate',
    reference: 'startReadDate',
    isRequired: 1,
    dataType: 'Date'
  }, {
    name: 'EndMeterDate',
    reference: 'endReadDate',
    isRequired: 1,
    dataType: 'Date'
  }, {
    name: 'StartMeterReading',
    reference: 'startMeterRead',
    isRequired: 0,
    dataType: 'Number'
  }, {
    name: 'EndMeterReading',
    reference: 'endMeterRead',
    isRequired: 0,
    dataType: 'Number'
  }, {
    name: 'MeterUsage',
    reference: 'meterUsage',
    isRequired: 1,
    dataType: 'Number'
  }, {
    name: 'Rate',
    reference: 'meterRate',
    isRequired: 0,
    dataType: 'Number'
  }, {
    name: 'UtilityUnit',
    reference: 'utilityUnit',
    isRequired: 1,
    dataType: 'String'
  }, {
    name: 'UtilityTotal',
    reference: 'utilityCharge',
    isRequired: 1,
    dataType: 'Number'
  }, {
    name: 'UtilityProvider',
    reference: 'utilityProviderName',
    isRequired: 0,
    dataType: 'String'
  }, {
    name: 'ServicePhone',
    reference: 'servicePhoneNumber',
    isRequired: 0,
    dataType: 'String'
  }]
}];
export const CSV_MAPS = [{
  name: 'initial',
  columns: [{
    name: 'UnitName',
    reference: 'unitName'
  }, {
    name: 'ResidentName',
    reference: 'residentName'
  }, {
    name: 'ConsumerName',
    reference: 'residentName'
  }, {
    name: 'ResidencyStatus',
    reference: 'residencyName'
  }, {
    name: 'SerialNumber',
    reference: 'serialNumber'
  }, {
    name: 'StartReadDate',
    reference: 'startReadDate'
  }, {
    name: 'EndReadDate',
    reference: 'endReadDate'
  }, {
    name: 'StartRead',
    reference: 'startMeterRead'
  }, {
    name: 'EndRead',
    reference: 'endMeterRead'
  }, {
    name: 'Usage',
    reference: 'meterUsage'
  }, {
    name: 'UnitsOfMeasure',
    reference: 'utilityUnit'
  }, {
    name: 'UtilityTotal',
    reference: 'utilityCharge'
  }]
}];
export const REDACTED_CSV_HEADERS = ['UnitName', 'ResidentName', 'ResidencyStatus', 'ResidentAccountId', 'SerialNumber', 'StartMeterDate', 'EndMeterDate', 'StartMeterReading', 'EndMeterReading', 'MeterUsage', 'Rate', 'UtilityUnit', 'UtilityTotal'];
export const CSV_DATA_TYPES = {
  string: 'String',
  number: 'Number',
  boolean: 'Boolean',
  date: 'Date'
};
export const CSV_COL_TYPES = {
  required: 1,
  optional: 0
};
export async function parseCsv(file, residencies) {
  const csvFormat = CSV_FORMATS[0];
  const csvMap = CSV_MAPS[0];
  let errors = [];
  const data = csvFormat.columns.map(column => {
    const mappedColumn = csvMap.columns.find(mapColumn => mapColumn.reference === column.reference);
    if (mappedColumn) {
      return _objectSpread(_objectSpread({}, mappedColumn), column);
    } else {
      return _objectSpread({}, column); // , ...{ name: '' }
    }
  });
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      dynamicTyping: header => {
        const headerObj = data.find(d => d.reference === header);
        return !!headerObj && headerObj.dataType === CSV_DATA_TYPES.number;
      },
      skipEmptyLines: 'greedy',
      beforeFirstChunk: chunk => {
        const rows = chunk.split(/\r\n|\r|\n/);
        const header = rows[0];
        const headings = header.split(',').map(h => h.trim());
        const missingColumns = [];
        (data || []).forEach(d => {
          const index = headings.indexOf(d.name);
          if (d.isRequired === CSV_COL_TYPES.required && index === -1) {
            missingColumns.push(d.name);
          }
          if (d.name) {
            headings[index] = d.reference;
          }
        });
        if (missingColumns.length) {
          const missedColumnsError = {
            code: 'missingColumns',
            message: "Some required column(s) are missing from the uploaded CSV: ".concat(missingColumns.join(', '), ".")
          };
          errors.push(missedColumnsError);
        }
        const newRows = [];
        newRows.push(headings);
        newRows.push(...rows.slice(1));
        return newRows.join('\r\n');
      },
      transform: (value, header) => {
        if (errors[0] && errors[0].code === 'missingColumns') {
          return value;
        } else {
          const headerObj = data.find(d => d.reference === header);
          if (headerObj) {
            if (headerObj.name == null) {
              return value;
              // } else if (headerObj.isRequired === CSV_COL_TYPES.optional) {
              //   return value;
            } else {
              if (value == '' || value == 'null' || value == 'undefined' || value == null || value == undefined) {
                if (headerObj.isRequired === CSV_COL_TYPES.required) {
                  errors.push({
                    code: 'missingValue',
                    message: "Value is missing for the required column: '".concat(headerObj.name, "'.")
                  });
                }
              } else {
                switch (headerObj.dataType) {
                  case CSV_DATA_TYPES.number:
                    const parsedValue = parseFloat(value.replace(/[^0-9.]+/g, ''));
                    if (!isNaN(parsedValue) && isFinite(parsedValue)) {
                      return parsedValue;
                    } else {
                      errors.push({
                        code: 'invalidType',
                        message: "Value '".concat(value, "' has invalid data type for column '").concat(headerObj.name, "'.")
                      });
                    }
                  case CSV_DATA_TYPES.date:
                    if (value && typeof value === 'string') {
                      const parsedVal = new Date(Date.parse(value.trim()));
                      const parsedIsDate = parsedVal instanceof Date && !isNaN(parsedVal.getTime());
                      if (!parsedIsDate) {
                        errors.push({
                          code: 'invalidType',
                          message: "Value '".concat(value, "' has invalid data type for column '").concat(headerObj.name, "'.")
                        });
                      }
                    } else {
                      errors.push({
                        code: 'invalidType',
                        message: "Value '".concat(value, "' has invalid data type for column '").concat(headerObj.name, "'.")
                      });
                    }
                    return value;
                  case CSV_DATA_TYPES.string:
                    if (value) {
                      return value.trim();
                    }
                }
              }
            }
          }
        }
      },
      complete: results => {
        let parsedData = results.data;
        if (errors.length) {
          errors = [...errors, ...results.errors];
        }
        // Units validation
        if (parsedData && parsedData.length) {
          const missingUnits = [];
          residencies.forEach(unit => {
            const unitData = parsedData.find(d => new String(d.unitName).valueOf() === unit.unitName && [RESIDENCY_STATUS_KEY_VALUES.Current, RESIDENCY_STATUS_KEY_VALUES.FormerActive].includes(unit.status) && typeof d.enrolled === 'undefined');
            if (!unitData) {
              missingUnits.push(unit.unitName);
            } else {
              unitData.unitId = unit.unitId;
              // Resident Data from Residencies response
              unitData.fullName = unit.fullname;
              unitData.newEmail = unit.newEmail;
              unitData.accountId = unit.accountId;
              unitData.recidencyStatus = unit.status;
              unitData.enrolled = true;
            }
          });
        }
        // Filter out columns those are not part of CSV format
        parsedData = parsedData.filter(unit => unit.enrolled === true).map(d => {
          for (const key in d) {
            if (d[key] === undefined || d[key] == null) {
              delete d[key];
            }
          }
          return d;
        });
        return resolve({
          fileName: file.name,
          csvData: parsedData,
          columnData: [],
          errors
        });
      },
      error: error => {
        return reject({
          fileName: file.name,
          csvData: [],
          columnData: [],
          errors: [error]
        });
      }
    });
  });
}
export function generateCsv(residensySetup) {
  const csvFormat = CSV_FORMATS[0];
  const headers = csvFormat.columns.map(f => f.name);
  const dataRows = (residensySetup || []).filter(o => [RESIDENCY_STATUS_KEY_VALUES.Current, RESIDENCY_STATUS_KEY_VALUES.FormerActive].includes(o.status)).map(r => [r.unitName, r.fullname, r.status, '', '', '', '', '', '', '', '', '', '']);
  return Papa.unparse({
    fields: headers,
    data: dataRows
  });
}
export function generateRedactedCsv(redactedCsv) {
  const dataRows = (redactedCsv || []
  //.filter(o => o.isEdited) // we can include only edited rows, just uncomment this
  ).map(r => [r.unitName, r.residentName, r.recidencyStatus, r.accountId, r.serialNumber, r.startReadDate, r.endReadDate, r.startMeterRead, r.endMeterRead, r.meterUsage, r.meterRate, r.utilityUnit, r.utilityCharge]);
  return Papa.unparse({
    fields: REDACTED_CSV_HEADERS,
    data: dataRows
  });
}